module.exports = __webpack_public_path__ + "img/1.9188e8b6.jpg";